/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-use-before-define */
import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import {
  Box,
  ListItem, ListItemIcon, ListItemText, Typography,
  Grid,
} from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import {
  Dashboard, Person, Store, ShoppingCart, ListAlt, MenuBook,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import GroupIcon from '@mui/icons-material/Group';
import Item from './item';
import { ItemModel } from '../../../pages/models';
import Options from './options';

// const useStyles = makeStyles((theme) => ({
//  button: {
//    // marginTop: theme.spacing(8),
//    height: '100%',
//  },
// }));

// .parallelogam {
//    width: 100px;
//    height: 50px;
//    -webkit-transform: skew(20deg);
//    -moz-transform: skew(20deg);
//    -o-transform: skew(20deg);
//    background: #66CC99;
//  }

// display: inline-grid;
//    height: 100%;
//    width: 100%;
//    justify-content: end;
//    justify-items: end;
//    align-items: end;
//    align-content: space-between;

export default function mainListItems(color:string):JSX.Element {
  return (
    <Box sx={{
      display: 'flex',
      marginTop: 0,
      width: '100%',
    }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {
            Options.map((el: ItemModel) => (
              <Item name={el.name} icon={el.icon} router={el.router} key={el.id} />
            ))
        }
      </Box>

    </Box>
  );
};
